import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import {Partenaires} from "./Home/Partenaires";
import {RechercheCalendrier} from "./Calendrier/RechercheCalendrier";
export const CalendrierVide = () => {

    return (
        <>
        <Helmet>
            <title>Calendrier de prospection</title>
            <meta name="description" content="Découvrez la carte de votre commune avec la localisation des points de prélèvements, les dates et les résultats de prospection" />
        </Helmet>
        <main class="type calendrier-resultats">
            <RechercheCalendrier />
            <Partenaires/>
        </main>
</>
)
}